import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Inter is self-hosted through the package, not fetched from a CDN — a fintech
// app should not tell a third party which pages its users open.
import '@fontsource-variable/inter';

import { App } from './app/App';
import { startMockServiceWorker } from './mocks/browser';
import { configureNovixApi } from './shared/api';

import './index.css';

// Before the first render, so no request can go out under the old transport.
configureNovixApi();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

// The mock worker must be listening BEFORE React mounts, otherwise the first
// query of the session escapes to the network. In production this resolves
// immediately without importing anything.
void startMockServiceWorker().then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
